import { makeAutoObservable } from 'mobx';
import TranslationScopeStore, { ITranslationScopeStore } from './translations-scope-store';

export interface ITranslationStore {
    loadScope(scope: string): ITranslationScopeStore;
    unloadScope(scope: string): void;
}

interface IScopesMap {
    [scope: string]: ITranslationScopeStore
}

class TranslationStore implements ITranslationStore {
    private scopesMap: IScopesMap = {};

	constructor() {
		makeAutoObservable(this);
	}

    public loadScope(scope: string): ITranslationScopeStore {
        if (!this.scopesMap[scope]) {
            this.scopesMap[scope] = new TranslationScopeStore(scope);
            this.scopesMap[scope].load();
        }
        return this.scopesMap[scope];
    }

    public unloadScope(scope: string): void {
        /** place to unload scopes if needed, there might be more than one context using same scope */
        /** not finished */
        // console.log(`called unloadScope('${scope}')`);
    }

}

export default new TranslationStore();



